<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
    </window-tab>

    <window-tab title="Data" icon="database">
      <album-select-group v-model="albumId"></album-select-group>
      <table class="table table-bordered table-responsive table-hover table-sm" v-if="pictures && pictures.length">
        <thead>
        <tr>
          <th>Image</th>
          <th>Title</th>
          <th>Order</th>
          <th>Frequency</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="picture in pictures">
          <td><img :src="picture.image" :title="picture.fileName"></td>
          <td class="inline-edit">
            <input type="text" class="inline-input form-control" v-model.lazy="titles[picture.pictureId]"
                   @change="updateRecords">
          </td>
          <td class="inline-edit">
            <input type="number" class="inline-input form-control" min="-10000" max="10000"
                   v-model.number.lazy="orders[picture.pictureId]" @change="updateRecords">
          </td>
          <td class="inline-edit">
            <input type="number" class="inline-input form-control" min="0" max="100"
                   v-model.number.lazy="frequencies[picture.pictureId]" @change="updateRecords">
          </td>
        </tr>
        </tbody>
      </table>
    </window-tab>

    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId">
        <div class="form-group row">
          <label :for="safeId('interval')" class="col-sm-4 col-form-label">Interval</label>
          <div class="col-sm-8">
            <input type="number" class="form-control" :id="safeId('interval')" v-model.number.lazy="interval">
          </div>
        </div>
        <div class="form-group row">
          <label :for="safeId('duration')" class="col-sm-4 col-form-label">Duration</label>
          <div class="col-sm-8">
            <input type="number" class="form-control" :id="safeId('duration')" v-model.number.lazy="duration">
          </div>
        </div>
      </template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapOverlayOptions, mapTemplateData } from '../../utils/index'
  import * as action from '@/store/action-types'

  export default {
    name: 'sponsors-auto',
    mixins: [templateMixin],
    computed: {
      ...mapTemplateData(['albumId']),
      ...mapTemplateData({
        'titles': {type: Object, default: {}},
        'orders': {type: Object, default: {}},
        'frequencies': {type: Object, default: {}}
      }),
      ...mapOverlayOptions({
        'interval': {type: Number, default: 55},
        'duration': {type: Number, default: 5}
      }),
      ...mapOverlayData(['title', 'imageUrl']),
      album () {
        return this.$store.getters.album(this.albumId) || {}
      },
      pictures () {
        return this.album.pictures || []
      }
    },
    methods: {
      updateRecords () {
        this.$store.dispatch(action.TEMPLATE_DATA, {
          templateId: this.templateId,
          data: {
            titles: this.titles,
            orders: this.orders,
            frequencies: this.frequencies
          }
        })
        const data = {
          pictures: this.pictures.map(p => {
            return {
              frequency: this.frequencies[p.pictureId] || 0,
              order: this.orders[p.pictureId] || 10001,
              title: this.titles[p.pictureId],
              imageUrl: p.image
            }
          })
        }
        data.pictures.sort((a, b) => a.order - b.order)
        this.$store.dispatch(action.TEMPLATE_OVERLAY_DATA, {
          templateId: this.templateId,
          data
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  td {
    height: 65px;
    text-align: center;
    padding: 0.1rem;
    vertical-align: middle;
  }

  td img {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/sponsors-auto.vue